module.exports = __webpack_public_path__ + "img/6.8568d1a8.jpg";